export default theme => ({
  root: {},
  container: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '32px 0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  svg: {
    width: 150
  }
});